
<app-loader></app-loader>

<router-outlet></router-outlet>


<div *ngIf="showNav() == true">
    <app-side-nav></app-side-nav>
</div>